import React, { useEffect, useState } from 'react';
import { MediaPlayer, MediaProvider } from '@vidstack/react';
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeftOutlined } from '@ant-design/icons';

function Player(props) {
    let [video, setVideo] = useState({})

    let navigate = useNavigate()

    let handleback = () => {
        navigate(-1)
    }

    let params = useParams()
    useEffect(() => {
        axios.get('/video/' + params.id)
            .then(res => {
                setVideo(res.data)
            })
    }, [])
    return (
        <div>
            <div onClick={handleback} style={{ cursor: 'pointer', padding: '10px', fontSize: '20px', marginBottom: '10px' }}><ArrowLeftOutlined /> Orqaga</div>
            <MediaPlayer title="Sprite Fight" src={video.url}>
                <MediaProvider />
                <DefaultVideoLayout thumbnails="https://files.vidstack.io/sprite-fight/thumbnails.vtt" icons={defaultLayoutIcons} />
            </MediaPlayer>
        </div>
    );
}

export default Player;